import { useMutation } from 'react-query';
import { UpdateDropBody } from './types';
import { checkDropAuth, client } from './droplrAuth';
import { omit } from 'lodash';
import { successToast } from 'lib/components/toasts/success';
import { errorToast } from 'lib/components/toasts/error';

export const editDrop = async (body: UpdateDropBody) => {
  await checkDropAuth();

  return client.drops.update(body.dropId, omit(body, 'dropId'));
};

export const useEditDrops = () => {
  return useMutation(async (bodies: UpdateDropBody[]) => {
    const results = await Promise.allSettled(
      bodies.map(body => editDrop(body))
    );

    const allSuccess = results.every(r => r.status === 'fulfilled');
    const someFailed = results.some(r => r.status === 'rejected');

    showUpdateToast(bodies, allSuccess, someFailed);

    return results;
  });
};

const showUpdateToast = (
  bodies: UpdateDropBody[],
  allSuccess: boolean,
  someFailed: boolean
) => {
  if (someFailed) {
    errorToast({ title: 'Failed to update files' });
    return;
  }

  if (!allSuccess) return;

  const message = `${bodies.length === 1 ? 'File' : 'Files'} updated successfully`;

  successToast({ title: message });
};
